const DEFAULT_STATE = {
    token: null,
    productField: {
        retrievedAt: 0,
        fields: [],
    },
    userInfo: {},
};

const fnList = {
    SALESFORCE_TOKEN: (state, payload) => {
        return {
            ...state,
            token: payload,
        };
    },
    LOGOUT_FIREBASE_USER: () => (
        DEFAULT_STATE
    ),
    PRODUCT_FIELD: (state, payload) => ({
        ...state,
        productField: {
            retrievedAt: new Date().getTime(),
            fields: payload,
        },
    }),
    USER_INFO: (state, payload) => ({
        ...state,
        userInfo: payload,
    }),
};


export default (state = DEFAULT_STATE, { type, payload }) => {
    const fn = fnList[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};
